import { ReactComponent as DocIcon } from './assets/docx.svg';
import { ReactComponent as FileIcon } from './assets/file.svg';
import { ReactComponent as JpgIcon } from './assets/jpg.svg';
import { ReactComponent as PdfIcon } from './assets/pdf.svg';
import { ReactComponent as PngIcon } from './assets/png.svg';
import { ReactComponent as XlsxIcon } from './assets/xlsx.svg';
import React from 'react';

export type MimeIconsType = { mime: string; extension: string; icon: React.FunctionComponent };
export const MimeIcons: MimeIconsType[] = [
  { extension: 'doc', icon: DocIcon, mime: 'application/msword' },
  { extension: 'docx', icon: DocIcon, mime: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' },
  { extension: 'jpeg', icon: JpgIcon, mime: 'image/jpeg' },
  { extension: 'jpg', icon: JpgIcon, mime: 'image/jpeg' },
  { extension: 'pdf', icon: PdfIcon, mime: 'application/pdf' },
  { extension: 'png', icon: PngIcon, mime: 'image/png' },
  { extension: 'xls', icon: XlsxIcon, mime: 'application/vnd.ms-excel' },
  { extension: 'xlsx', icon: XlsxIcon, mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
  { extension: '', icon: FileIcon, mime: 'application/octet-stream' },
];

export const getIconByExt = (filename: string): React.FunctionComponent => {
  const splitted = filename.split('.');
  const ext = splitted.length < 2 ? '' : splitted.pop() ?? ''.toLowerCase();
  for (let record of MimeIcons) {
    if (record.extension === ext) {
      return record.icon;
    }
  }
  return FileIcon;
};
